import { Component, Input } from '@angular/core';

@Component({
  selector: 'wiki-markdown-guide',
  template: require('./wiki.markdown-guide.component.html')
})
export class WikiMarkdownGuideComponent {
  @Input() context: 'wiki' | 'notebook' = 'wiki';
  @Input() showMacrosNote: boolean = false;
}
